// extracted by mini-css-extract-plugin
export default {"root":"ProductSelectionPanel__root___T1vbE","count":"ProductSelectionPanel__count___x_axi","actions":"ProductSelectionPanel__actions___geUxV"};